import { useEffect, useRef } from 'react';
import { subscribe } from './client';

/**
 * Subscribes the component to a topic for as long as it is mounted.
 * `onEvent` is read through a ref so an inline callback does not reopen the
 * stream on every render.
 */
export const useRealtime = (topic, onEvent) => {
  const callback = useRef(onEvent);
  callback.current = onEvent;

  useEffect(() => {
    if (!topic) return undefined;
    return subscribe(topic, (payload) => callback.current?.(payload));
  }, [topic]);
};

export default useRealtime;
